import { Stack, Typography, SxProps, Box } from '@mui/material';
import {
	boxPromo1SX,
	promo1TitleBoxSX,
	promo1DescriptionBoxSX,
	boxPromo2SX,
	promo2TitleBoxSX,
	promo2DescriptionBoxSX,
} from '@/components/blocks/DpLibrary/DpPromo/style/main';

export const DpPromo = ({
	promo,
	description,
	type,
}: {
	promo: string;
	description: string;
	type: 'promo1' | 'promo2';
	sxcontainer?: SxProps;
}) => (
	<Box display={'flex'} flexDirection={'row'} sx={type === 'promo1' ? boxPromo1SX : boxPromo2SX}>
		<Stack direction="row" spacing={0}>
			<Typography gutterBottom sx={type === 'promo1' ? promo1TitleBoxSX : promo2TitleBoxSX}>
				{`• ${promo}`}{' '}
				<Typography
					gutterBottom
					sx={type === 'promo1' ? promo1DescriptionBoxSX : promo2DescriptionBoxSX}
				>
					{description}
				</Typography>
			</Typography>
		</Stack>
	</Box>
);
